import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import accountAuthReducer from './slices/accountAuthSlice';

export const store = configureStore({
  reducer: {
    // Candidate / JMS realm (jobs portal, /profile)
    auth: authReducer,
    // Organization realm (owner account console, /account)
    accountAuth: accountAuthReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
